// extracted by mini-css-extract-plugin
export default {"grid":"Testimonials_grid__cA-bV","quote":"Testimonials_quote__lZCNk","name":"Testimonials_name__CwECr","title":"Testimonials_title__CJiVt"};